class ProductGrouping extends HTMLElement {
  constructor() {
    super();
    this.parentComponent = this
    // this.sectionName = this.getAttribute('data-section-name');
    this.sectionId = this.getAttribute('data-section-id');
    this.optionsToRequestData = this.querySelectorAll('[js-request-new-product]');
    this.buttonsToUpdateSubOptions = this.querySelectorAll('[js-update-sub-option]');
    this.buttonsToUpdateVariant = this.querySelectorAll('[js-update-variant]');

    this.defaultVariantId = this.getAttribute('data-default-variant-id');
    this.currentProductId = this.getAttribute('data-current-product-id');
    this.currentVariantId = this._getVariantFromURL();
    this.currentVariantAvailable = this.getAttribute('data-default-variant-available') === 'true';
    this.currentProductHandle = this.getAttribute('data-current-product-handle');
    // this.currentSize = this.getAttribute('data-current-size');
    this.currentOptions = {
      option2: this.getAttribute('data-current-option2'),
      option3: this.getAttribute('data-current-option3')
    }

    // new: either explicitly flagged _or_ living inside the <quick-view-modal> tag
    this.isQuickView = this.dataset.isQuickView === 'true'
    || Boolean(this.closest('quick-view-modal'));

    
    this.productGroupingData = {};
    this.dataProductGroup = JSON.parse(this.querySelector("script[data-product-group]")?.textContent || "{}");
    this._checkAndSetDefaultVariant();
    this._bindEvents();
    this._setupSizeGuide();
  }

  _setupSizeGuide() {
    // Select the modal and button
    this.sizeGuideButton = document.querySelector(".open-size-guide");
    this.sizeGuideModal = document.querySelector(".size-guide-modal");
    this.closeButton = document.querySelector(".modal-close");
    this.modalContent = document.querySelector(".modal-content");

    if (this.sizeGuideButton) {
      this.sizeGuideButton.addEventListener("click", () =>
        this.openSizeGuideModal()
      );
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () =>
        this.closeSizeGuideModal()
      );
    }

    // Add click event listener to the modal itself
    if (this.sizeGuideModal) {
      this.sizeGuideModal.addEventListener("click", (event) => {
        // Check if the click was outside the modal content
        if (event.target === this.sizeGuideModal) {
          this.closeSizeGuideModal();
        }
      });
    }

    // Close modal on Escape key
    document.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        this.sizeGuideModal.classList.contains("active")
      ) {
        this.closeSizeGuideModal();
      }
    });

    // Handle tab switching
    this.tabButtons = document.querySelectorAll(
      ".size-guide-tab-buttons .tab-button"
    );
    this.tabPanels = document.querySelectorAll(
      ".size-guide-tab-content .tab-panel"
    );

    this.tabButtons.forEach((button) => {
      button.addEventListener("click", (event) => this.switchTab(event));
    });

    // Ensure the modal updates when product grouping is injected
    window.addEventListener("productGroupingInjected", () =>
      this._updateSizeGuide()
    );
  }

  switchTab(event) {
    const selectedTab = event.target.getAttribute("data-tab");

    // Remove active class from all buttons and panels
    this.tabButtons.forEach((btn) => btn.classList.remove("active"));
    this.tabPanels.forEach((panel) => panel.classList.remove("active"));

    // Add active class to the clicked button and corresponding panel
    event.target.classList.add("active");
    document.getElementById(selectedTab).classList.add("active");
  }

  openSizeGuideModal() {
    this.sizeGuideModal.classList.add("active");
    document.body.classList.add("modal-open");
    this._generateSizeChartTabs(); // Call it here!
  }

  closeSizeGuideModal() {
    this.sizeGuideModal.classList.remove("active");
    document.body.classList.remove("modal-open");
  }

  _generateSizeChartTabs() {
    const sizeChartContent = document.querySelector("#size-chart-content");
    if (!sizeChartContent) return;
  
    const tables = sizeChartContent.querySelectorAll("table");
    const paragraphs = sizeChartContent.querySelectorAll("p");
  
    if (tables.length === 0) return;
  
    let subTabsHTML = `<div class="size-guide-sub-tabs" role="tablist">`;
    let subContentHTML = `<div class="size-guide-sub-tab-content">`;
  
    tables.forEach((table, index) => {
      let label = `Size Chart ${index + 1}`;
  
      for (let i = paragraphs.length - 1; i >= 0; i--) {
        if (paragraphs[i].nextElementSibling === table && paragraphs[i].textContent.trim() !== "") {
          label = paragraphs[i].textContent.trim();
          break;
        }
      }
  
      subTabsHTML += `<button class="sub-tab-button ${index === 0 ? 'active' : ''}" data-sub-tab="sub-tab-${index}" role="tab" aria-controls="sub-tab-${index}" aria-selected="${index === 0 ? 'true' : 'false'}">${label}</button>`;
      subContentHTML += `<div class="sub-tab-panel ${index === 0 ? 'active' : ''}" id="sub-tab-${index}" role="tabpanel">${table.outerHTML}</div>`;
    });
  
    subTabsHTML += `</div>`;
    subContentHTML += `</div>`;
  
    sizeChartContent.innerHTML = subTabsHTML + subContentHTML;
  
    document.querySelectorAll(".sub-tab-button").forEach(button => {
      button.addEventListener("click", function () {
        const tab = this.getAttribute("data-sub-tab");
  
        document.querySelectorAll(".sub-tab-button").forEach(btn => btn.classList.remove("active"));
        document.querySelectorAll(".sub-tab-panel").forEach(panel => panel.classList.remove("active"));
  
        this.classList.add("active");
        document.getElementById(tab).classList.add("active");
      });
    });
  }

  _updateSizeGuide() {
    const productTags = this.getAttribute("data-product-tags") || "";
    const sizeGuideHandle = this._extractSizeGuideHandle(productTags);

    if (sizeGuideHandle) {
      fetch(`/pages/${sizeGuideHandle}`)
        .then((response) => response.text())
        .then((text) => {
          document.querySelector("#size-chart-content").innerHTML = text;
        })
        .catch((error) => {
          console.error("Error loading size guide:", error);
          document.querySelector("#size-chart-content").innerHTML = "Failed to load size guide.";
        });
    }
  }

  _extractSizeGuideHandle(tags) {
    const match = tags.split(",").find((tag) => tag.includes("size-guide:"));
    return match ? tag.split(":")[1] : "";
  }

  _checkAndSetDefaultVariant() {
    if (!this.currentVariantId && this.defaultVariantId) {
      this._updateURLWithVariant(this.defaultVariantId);
      this.currentVariantId = this.defaultVariantId;
    }

    const scriptTagsData = this.querySelectorAll("script[js-product-group-data]");
    this.productGroupingData = Array.from(scriptTagsData).reduce((acc, script) => {
      const data = JSON.parse(script.textContent)
      const key = script.getAttribute("data-product-id")
      if (!acc[key]) {
        acc[key] = {
          tag_options: [],
          variants: []
        }
      }
    
      const existingData = acc[key]
      existingData.tag_options.push(...data.tag_options)
      const uniqueVariants = data.variants.filter(newVariant => 
        !existingData.variants.some(existingVariant => existingVariant.id === newVariant.id)
      );
      existingData.variants.push(...uniqueVariants);
    
      return acc
    }, {})

    if (!this.currentVariantAvailable) {
      const addToCartForm = document.querySelector('.product-info .shopify-product-form')
      const addToCartButton = addToCartForm.querySelector('buy-buttons button[type="submit"]')
      const notifyMeBtn = addToCartForm.querySelector('buy-buttons button[data-bis-trigger]')
      const addToCartButtonText = addToCartButton.querySelector('div')
      const soldOutElement = this.closest('.product-info').querySelector('sold-out-badge');
      this.showJoinWaitListButton(addToCartButton, notifyMeBtn, addToCartButtonText, soldOutElement)

      const $submit = document.querySelectorAll('product-quick-add .buy-buttons__submit');
      $submit.forEach(submit => {
        submit.addEventListener('click', this._scrollToBuyButtons);
      });
    }
  }

  _getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  _updateURLWithVariant(variantId) {
    if (this.isQuickView) return
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  _bindEvents() {
    this.optionsToRequestData.forEach(option => {
      option.addEventListener('click', (event) => this._handleOptionChange(event, option));
    });

    this.buttonsToUpdateVariant.forEach(button => {
      button.addEventListener('click', (event) => this._handleUpdateVariant(event, button));
    });
    document.querySelector('#main-product-info.has-fade-in')?.classList.add('is-visible');
  }

  _handleColorChange(event, swatch) {
    event.preventDefault();
    const newProductHandle = swatch.dataset.productHandle;

    if (newProductHandle) {
      window.location.href = `/products/${newProductHandle}`
    }
  }

  _handleUpdateVariant(event, button) {
    event.preventDefault()
    const newVariantId = button.dataset.variantId;
    const newVariantPrice = button.dataset.variantPrice;
    const isAvailable = button.dataset.available === 'true';
    const optionIndex = button.dataset.optionIndex;
    const newValue = button.dataset.value;

    const addToCartForm = document.querySelector('.product-info .shopify-product-form')
    const input = addToCartForm?.querySelector('input[name="id"]')
    const soldOutElement = this.closest('.product-info').querySelector('sold-out-badge');

    this.currentOptions[`option${optionIndex}`] = newValue
    this.currentVariantId = newVariantId;
    input.value = newVariantId
    this.updateVariantClass()

    this._updateURLWithVariant(newVariantId);

    const addToCartButton = addToCartForm.querySelector('buy-buttons button[type="submit"]')
    const notifyMeBtn = addToCartForm.querySelector('buy-buttons button[data-bis-trigger]')
    const addToCartButtonText = addToCartButton.querySelector('div')
    
    if (isAvailable) {
      // Check if product has preorder tag
      const isPreorder = document
        .querySelector("#main-product-info")
        ?.classList.contains("preorder");

      // Product Info
      addToCartButton.removeAttribute("disabled");
      addToCartButton.classList.remove("button--subdued");
      const num = parseFloat((newVariantPrice || '').replace(/[^0-9.]/g, '')) || 0;
      const formatted = num.toLocaleString(undefined, {
        style: 'currency',
        currency: 'USD',
      });
      const quickViewPrice = isNaN(num) ? 0 : num;

      if (isPreorder) {
        addToCartButtonText.textContent = "PREORDER";
      } else {
        addToCartButtonText.textContent = `Add to Bag - ${formatted}`;
      }

      addToCartButton.style = "display: block;";
      notifyMeBtn.style = "display: none;";
      soldOutElement?.classList.add("is-hidden");
    } else {
      this.showJoinWaitListButton(addToCartButton, notifyMeBtn, addToCartButtonText, soldOutElement)
    }

    this.updateQuickAddCTA(isAvailable, newVariantId, newVariantPrice)
  }
  updateQuickAddCTA(isAvailable, newVariantId, newVariantPrice) {
    document.querySelectorAll('product-quick-add').forEach(quickAdd => {
      const $submit = quickAdd.querySelector('.buy-buttons__submit');
      const input = quickAdd.querySelector('input[name="id"]');
      input.value = newVariantId;
      // $submit.disabled = !isAvailable;

      if (isAvailable) {
        // Check if product has preorder tag
        const isPreorder = document
          .querySelector("#main-product-info")
          ?.classList.contains("preorder");
        if (isPreorder) {
          $submit.querySelector(
            "div"
          ).innerHTML = `PREORDER - ${newVariantPrice}`;
        } else {
          $submit.querySelector(
            "div"
          ).innerHTML = `Add to bag - ${newVariantPrice}`;
        }
        $submit.setAttribute("type", "submit");
        $submit.removeEventListener("click", this._scrollToBuyButtons);
      } else {
        $submit.querySelector('div').innerHTML = 'Join Waitlist';
        $submit.setAttribute('type', 'button');
        $submit.addEventListener('click', this._scrollToBuyButtons);
      }
    });
  }
  

  _scrollToBuyButtons(event) {
    event.preventDefault();
    const scrollToElement = document.querySelector('.product-info__buy-buttons');
    if (scrollToElement) {
      scrollToElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  updateVariantClass() {
    Object.values(this.currentOptions).forEach((data, index) => {
      const optionIndex = index + 2
      const row = this.querySelector(`.product-grouping__options[data-options-row="${optionIndex}"]`);
      if (optionIndex == 2) {
        row?.querySelectorAll('button[js-update-variant]').forEach(button => {
          const isVisible = button.dataset.option3 === this.currentOptions.option3
          const isActive = button.dataset.value === this.currentOptions[`option${optionIndex}`]
          button.classList.toggle('is-active', isActive)
          button.classList.toggle('is-hidden', !isVisible)
        })
      }
      if (optionIndex == 3) {
        row?.querySelectorAll('button[js-update-variant]').forEach(button => {
          const isVisible = button.dataset.option2 === this.currentOptions.option2
          const isActive = button.dataset.value === this.currentOptions[`option${optionIndex}`]
          button.classList.toggle('is-active', isActive)
          button.classList.toggle('is-hidden', !isVisible)
        })
      }
    })
  }

  showJoinWaitListButton(addToCartButton, notifyMeBtn, addToCartButtonText, soldOutElement) {
    if (addToCartButton) { 
      addToCartButton.style = 'display: none;'
      // addToCartButton.setAttribute('disabled', true)
      // addToCartButton.classList.add('button--subdued')
    }
    if (addToCartButtonText) {
      addToCartButtonText.textContent = 'Sold Out'
    }
    notifyMeBtn.style = 'display: block;'
    soldOutElement?.classList.remove('is-hidden')
  }

  async _handleOptionChange(event, option) {
    event.preventDefault();
    if (option.classList.contains('is-disabled')) return;

    const newProduct = option.dataset.productHandle;
    const loadedIds = this.dataProductGroup?.loaded_ids?.replace(/"/g, '') || false;

    if (newProduct && newProduct !== this.currentProductHandle) {
      try {
        this.parentComponent.classList.add('is-loading');

        // const optionsResponse = await fetch(`/products/${newProduct}?view=sizes-ajax&section_id=${this.sectionId}`);
        // const optionsResponse = await fetch(`/products/${newProduct}?view=options-ajax`);
        // const optionsText = await optionsResponse.text();
        // const optionsArray = JSON.parse(optionsText);
        // const newVariantIDBasedOnOptions = optionsArray
        //   .find(variant => 
        //     variant.option2 === this.currentOptions.option2 && 
        //     (variant.option3 === this.currentOptions.option3 || variant.option3 === null)
        //   )?.id;

        let url = new URL(window.location.origin + `/products/${newProduct}`);
        let params = new URLSearchParams();

        params.set('view', 'product-info-ajax');
        params.set('section_id', this.sectionId);
        params.set('no-fade-in', 'true');

        if (loadedIds) {
          params.set('product-group-ids', loadedIds);
        }

        // if (newVariantIDBasedOnOptions) {
        //   params.set('variant', newVariantIDBasedOnOptions);
        // }

        url.search = params.toString();  
        const decodedURL = url.toString().replace(/%2B/g, '+'); 
        console.log(' decodedURL:', decodedURL)

        // window.location.href =
        //   `${url.origin}/products/${newProduct}${newVariantIDBasedOnOptions
        //       ? `?variant=${newVariantIDBasedOnOptions}`
        //       : ''}`;

        const response = await fetch(decodedURL);
        const text = await response.text();
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(text, 'text/html');

        const newMainProduct = newDocument.querySelector('#main-product-info');
        
        const currentMainProduct = this.isQuickView
          ? document.querySelector('quick-view-modal .quick-add-modal')
          : document.querySelector('#main-product-info');       

        this.firstVariantId = newMainProduct.getAttribute('data-first-variant');
        this.productId = newMainProduct.getAttribute('data-product-id');
        this.currentProductHandle = this.getAttribute('data-product-handle');
        this.currentProductId = this.productId

        if (newMainProduct && currentMainProduct) {
          this.isQuickView 
            ? currentMainProduct.innerHTML = newMainProduct.innerHTML
            : currentMainProduct.replaceWith(newMainProduct);
        }

        const scripts = Array.from(newMainProduct.querySelectorAll("script")).filter(
          script => !script.hasAttribute("data-product-group")
        );
        scripts.forEach(oldScript => {
          const newScript = document.createElement("script");
          // const newScript = Array.from(newMainProduct.querySelectorAll("script")).filter(
          //   script => !script.hasAttribute("data-product-group")
          // );
          newScript.textContent = oldScript.textContent;
          document.body.appendChild(newScript);
          document.body.removeChild(newScript);
        });

        window.dispatchEvent( new Event('productGroupingInjected') );

        if (this.isQuickView) {
          // Skip Yotpo initialization for quick view
        } else {
          params.delete('view');
          params.delete('section_id');
          params.delete('no-fade-in');
          if (loadedIds) {
            params.delete('product-group-ids');
          }

          url.search = params.toString();
          window.history.pushState({}, '', url.toString());

          const optionColor = document.querySelector(`button[data-product-handle="${newProduct}"]`);

          // QuickAdd
          const currentQuickAdd = document.querySelector('#quick-add--sticky');
          const newQuickAdd = newDocument.querySelector('#quick-add--sticky');
          currentQuickAdd.replaceWith(newQuickAdd)

          setTimeout(() => {
            // Only initialize Yotpo if not in quick view
            if (!this.isQuickView) {
              window.yotpoWidgetsContainer?.initWidgets();
            }
            if (optionColor) {
              optionColor.focus();
            }
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
            if (isMobile) {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }, 300);
        }

        this.currentProductHandle = newProduct;
      } catch (error) {
        console.error('Error fetching new product data:', error);
      } finally {
        this.parentComponent.classList.remove('is-loading');
      }
    }
  }  
}

customElements.define('product-grouping', ProductGrouping);
